(() => {
  if (window.WCPairing) { window.WCPairing.init(); return; }
  const API = { busy: false, roots: [], locked: [] };
  const base = () => window.Shopify?.routes?.root || '/';
  async function json(url, options) {
    const r = await fetch(url, options); let data;
    try { data = await r.json(); } catch (_) { throw new Error('Please wait a moment, then check your cart.'); }
    if (!r.ok) throw new Error(data.description || data.message || 'Unable to update the cart.');
    return data;
  }
  const getCart = () => json(base() + 'cart.js');
  const hostFor = root => root.closest('#wc-product-hero-v7, [id^="nm-buy-"], #spe');
  const mainButtons = host => [...(host?.querySelectorAll('#wc-v7-add-cart, [data-nm-atc], [data-nm-buynow], [data-spe-atc], [data-spe-buynow]') || [])];
  const eligibleIds = root => root.dataset.eligibleProducts.split(',').map(Number).filter(Boolean);
  const hasMain = (cart, root) => cart.items.some(i => eligibleIds(root).includes(Number(i.product_id)) && i.quantity > 0);
  function hasDiscount(cart) {
    return cart.items.some(i => i.line_level_discount_allocations?.some(a => a.amount > 0 && /^(Magnesium add-on 15%|Pairs Well With 15%)/.test(a.discount_application?.title || '')));
  }
  function setBusy(on) {
    API.busy = on;
    API.roots.forEach(r => r.querySelectorAll('[data-wc-pair-add]').forEach(b => b.disabled = on));
    if (on) {
      const buttons = [...new Set(API.roots.flatMap(r => mainButtons(hostFor(r))))];
      API.locked = buttons.map(b => ({ b, wasDisabled: b.disabled }));
      API.locked.forEach(x => x.b.disabled = true);
    } else { API.locked.forEach(x => x.b.disabled = x.wasDisabled); API.locked = []; }
  }
  API.setBusy = setBusy;
  function updateLabels(cart) {
    const discounted = hasDiscount(cart);
    API.roots.forEach(root => {
      const main = hasMain(cart, root);
      const ids = [...root.querySelectorAll('[data-wc-pair-add]')].map(b => Number(b.dataset.product));
      const addon = cart.items.some(i => ids.includes(Number(i.product_id)) && !i.selling_plan_allocation);
      root.querySelectorAll('[data-wc-pair-add]').forEach(b => b.textContent = !main ? discounted ? 'Add both to cart' : 'Add both & save 15%' : discounted || addon ? 'Add to cart' : 'Add with 15% off');
    });
  }
  function getSelection(root) {
    const host = hostFor(root);
    if (host?.wcGetSelection) return host.wcGetSelection();
    const form = host?.querySelector('form[action*="/cart/add"]');
    if (!form) throw new Error('Choose your product options before adding the pair.');
    const fd = new FormData(form);
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
    const properties = {};
    for (const [key, value] of fd.entries()) { const match = /^properties\[([^\]]+)\]$/.exec(key); if (match) properties[match[1]] = value; }
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }
  async function renderCart(cart, added) {
    const drawer = document.querySelector('cart-drawer');
    const sections = await json(base() + '?sections=cart-drawer,cart-icon-bubble');
    if (drawer && typeof drawer.renderContents === 'function' && sections['cart-drawer']) {
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      drawer.renderContents({ id: added?.id, sections });
    } else if (sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const icon = document.querySelector('#cart-icon-bubble');
      const next = doc.querySelector('#shopify-section-cart-icon-bubble');
      if (icon && next) icon.innerHTML = next.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('wc:cart-updated', { detail: { cart } }));
    updateLabels(cart);
  }
  API.refreshCart = async () => { const cart = await getCart(); await renderCart(cart); return cart; };
  API.init = () => {
    document.querySelectorAll('[data-wc-pairing]').forEach(root => {
      if (root.dataset.wcReady) return;
      root.dataset.wcReady = 'true'; API.roots.push(root);
      if (!root.querySelector('.wc-pairing__card')) { root.hidden = true; return; }
      root.querySelectorAll('[data-wc-pair-add]').forEach(button => button.addEventListener('click', async () => {
        const status = root.querySelector('.wc-pairing__status');
        if (API.busy || mainButtons(hostFor(root)).some(b => b.disabled || b.getAttribute('aria-disabled') === 'true')) {
          status.hidden = false; status.textContent = 'Please wait for the current cart update.'; return;
        }
        setBusy(true); const original = button.textContent; button.textContent = 'Adding…';
        status.hidden = false; status.textContent = 'Updating your cart…';
        const cartLink = root.querySelector('.wc-pairing__view-cart'); cartLink.hidden = true;
        let sent = false;
        try {
          const before = await getCart();
          const items = [{ id: Number(button.dataset.variant), quantity: 1, properties: { _wc_add_on: 'pairs-well-with' } }];
          if (!hasMain(before, root)) {
            const main = getSelection(root);
            if (!main.id || !Number.isInteger(main.quantity) || main.quantity < 1) throw new Error('Select an available product option.');
            items.unshift(main);
          }
          sent = true;
          const added = await json(base() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const cart = await getCart();
          status.textContent = 'Added to cart. The best eligible 15% offer applies to one item per order; check your cart.';
          cartLink.hidden = false;
          try { await renderCart(cart, added.items?.[0]); } catch (_) { updateLabels(cart); }
        } catch (e) {
          status.textContent = sent ? 'We could not confirm the cart update. Check your cart before trying again. ' + e.message : e.message;
          cartLink.hidden = !sent;
          if (sent) { try { updateLabels(await getCart()); } catch (_) {} }
        } finally { setBusy(false); if (button.textContent === 'Adding…') button.textContent = original; }
      }));
    });
    getCart().then(updateLabels).catch(() => {});
  };
  window.WCPairing = API;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', API.init); else API.init();
  document.addEventListener('shopify:section:load', API.init);
  document.addEventListener('wc:cart-updated', e => { if (e.detail?.cart) updateLabels(e.detail.cart); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => getCart().then(updateLabels).catch(() => {}));
})();
